import { Action } from "@ngrx/store";
import { type } from "../../util";
import {
  LoginData,
  RecoverPasswordData,
  RegisterData,
  ResetPasswordData,
} from "./auth.model";

/**
 * Action Types
 */
export const ActionTypes = {
  CHECK_LOGIN: type("[Auth] Check Login"),
  LOGIN: type("[Auth] Login"),
  LOGIN_SUCCESS: type("[Auth] Login Success"),
  LOGIN_FAIL: type("[Auth] Login Fail"),
  LOGOUT: type("[Auth] Logout"),
  REGISTER: type("[Auth] Register"),
  REGISTER_SUCCESS: type("[Auth] Register Success"),
  REGISTER_FAIL: type("[Auth] Register Fail"),
  RESET_PASSWORD: type("[Auth] Reset Password"),
  RESET_PASSWORD_SUCCESS: type("[Auth] Reset Password Success"),
  RESET_PASSWORD_FAIL: type("[Auth] Reset Password Fail"),
  RECOVER_PASSWORD: type("[Auth] Recover Password"),
  RECOVER_PASSWORD_SUCCESS: type("[Auth] Recover Password Success"),
  RECOVER_PASSWORD_FAIL: type("[Auth] Recover Password Fail"),
  AUTH_NO_ACTION: type("[Auth] No Action"),
};

/**
 * Actions
 */
export class CheckAction implements Action {
  type = ActionTypes.CHECK_LOGIN;
}

export class LoginAction implements Action {
  type = ActionTypes.LOGIN;
  constructor(public payload: LoginData) {}
}

export class LoginSuccessAction implements Action {
  type = ActionTypes.LOGIN_SUCCESS;
  constructor(public payload?: any) {}
}

export class LoginFailAction implements Action {
  type = ActionTypes.LOGIN_FAIL;
  constructor(public payload?: any) {}
}

export class LogoutAction implements Action {
  type = ActionTypes.LOGOUT;
}

export class RegisterAction implements Action {
  type = ActionTypes.REGISTER;
  constructor(public payload: RegisterData) {}
}

export class RegisterSuccessAction implements Action {
  type = ActionTypes.REGISTER_SUCCESS;
  constructor(public payload?: any) {}
}

export class RegisterFailAction implements Action {
  type = ActionTypes.REGISTER_FAIL;
  constructor(public payload?: any) {}
}

export class ResetPasswordAction implements Action {
  type = ActionTypes.RESET_PASSWORD;
  constructor(public payload: ResetPasswordData) {}
}

export class ResetPasswordSuccessAction implements Action {
  type = ActionTypes.RESET_PASSWORD_SUCCESS;
  constructor(public payload?: any) {}
}

export class ResetPasswordFailAction implements Action {
  type = ActionTypes.RESET_PASSWORD_FAIL;
  constructor(public payload?: any) {}
}

export class RecoverPasswordAction implements Action {
  type = ActionTypes.RECOVER_PASSWORD;
  constructor(public payload: RecoverPasswordData) {}
}

export class RecoverPasswordSuccessAction implements Action {
  type = ActionTypes.RECOVER_PASSWORD_SUCCESS;
  constructor(public payload?: any) {}
}

export class RecoverPasswordFailAction implements Action {
  type = ActionTypes.RECOVER_PASSWORD_FAIL;
  constructor(public payload?: any) {}
}

export class AuthNoAction implements Action {
  type = ActionTypes.AUTH_NO_ACTION;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Action =
  | LoginAction
  | LoginSuccessAction
  | LoginFailAction
  | LogoutAction
  | RegisterAction
  | RegisterSuccessAction
  | RegisterFailAction
  | ResetPasswordAction
  | ResetPasswordSuccessAction
  | ResetPasswordFailAction
  | RecoverPasswordAction
  | RecoverPasswordSuccessAction
  | RecoverPasswordFailAction
  | AuthNoAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/auth/auth.actions.ts